module.exports = __webpack_public_path__ + "static/media/29BDOS16.00200d97.jpg";